import { ChangeDetectionStrategy, Component, computed, inject, output, input } from '@angular/core';

import { TimeService } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { InterviewResultRequest } from '@core/interview-result-request-types';
import { DateComponent } from '@core/time-ui';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-interview-request-item',
  templateUrl: 'interview-request-item.component.html',
  styleUrls: ['./interview-request-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, DateComponent, ButtonComponent, TranslatePipe],
})
export class InterviewRequestItemComponent {
  private readonly timeService = inject(TimeService);

  protected readonly dueDateLabel = computed(() => {
    const dueDate = this.request()?.dueDate;

    return dueDate ? this.timeService.format({ input: dueDate, pattern: 'D MMM' }) : null;
  });

  public readonly request = input<InterviewResultRequest>(undefined!);

  public startEvaluationClick = output<InterviewResultRequest>();
}
